<template>
  <template v-if="item" v-for="outerSection in dataConfig.form">
    <div class="gen-form-box" :class="'col-md-'+section.cols" v-for="section in outerSection.fields?[outerSection]:outerSection.groups" v-show="outerSection.id==activeTab || !activeTab">
      <div class="gfb-title" v-if="false">
        <h3>{{ "" }}</h3>
      </div>
      <div class="gf-row">
        <div :class="'col-md-'+field.cols" v-for="field of section.fields">
          <label :class="(field.labelClass || '')+' '+formLabelClassFor(field)">
            <template v-if="item.parent && dataConfig.hasInheritance">
              <i class="fa-solid fa-link" v-if="isInherited(field)" @click="uninheritField(field)" />
              <i class="fa-solid fa-link-slash" v-else @click="inheritField(field)" />
            </template>
            {{ field.label }}
          </label>
          <template v-if="item.parent && dataConfig.hasInheritance && isInherited(field)">
            <div class="inherited-value" tabindex="-1" inert>
              <component :is="formComponentFor(field)" v-bind="formArgsFor(field)" v-model="item.parent[field.id]" :item="item" :field="field" :dbfield="(field.dbfield || fieldDesc[field.id])" v-if="!(field.dbfield || fieldDesc[field.id])?.localize" />
              <component :is="formComponentFor(field)" v-bind="formArgsFor(field)" v-model="parentCurrentLocalization((field.dbfield || fieldDesc[field.id])?.localize)[field.id]" :item="item" :field="field" :dbfield="(field.dbfield || fieldDesc[field.id])" v-else />
            </div>
          </template>
          <template v-else>
            <component :is="formComponentFor(field)" v-bind="formArgsFor(field)" v-model="item[field.id]" :item="item" :field="field" :dbfield="(field.dbfield || fieldDesc[field.id])" v-if="!(field.dbfield || fieldDesc[field.id])?.localize" />
            <component :is="formComponentFor(field)" v-bind="formArgsFor(field)" v-model="currentLocalization((field.dbfield || fieldDesc[field.id])?.localize)[field.id]" :item="item" :field="field" :dbfield="(field.dbfield || fieldDesc[field.id])" v-else />
          </template>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import api from '@/Util/api';
import { resolveComponent } from 'vue';

var fieldTypeMap={
  text: ["textAuto"],
  longtext: ["textAuto"],
  mediumtext: ["textAuto"],
  email: ["input", {type: "email"}],
  'int(1)': ["checkbox"],
  'relUuid': ["relOne"],
  'relManyUuid': ["relMany"],
};

export default {
  props: ["params", "item", "localizations", "autoSlug", "activeTab"],
  data: ()=>({
    temporarilyUninherited: [],
  }),
  computed: {
    dataConfig() {
      return this.stores.config.config?.data?.[this.params?.type];
    },
    fieldDesc() {
      return this.stores.auth.typeDesc?.[(this.params?.dataType) || (this.params?.type)] ?? {};
    },
  },
  watch: {
    item: {
      handler() {
        if (Array.isArray(this.item))
          this.$emit("update:item", {});
      }, immediate: true
    },
  },
  methods: {
    isInherited(field) {
      var value=((field.dbfield || this.fieldDesc[field.id])?.localize?this.currentLocalization((field.dbfield || this.fieldDesc[field.id])?.localize):this.item)[field.id];
      if (this.temporarilyUninherited.indexOf(field.id)!=-1)
        return false;
      if (value==null)
        return true;
      if (Array.isArray(value) && value.length==0)
        return true;
      if (Array.isArray(value.target) && value.target.length==0)
        return true;
      return false;
    },
    uninheritField(field) {
      if (this.temporarilyUninherited.indexOf(field.id)==-1)
        this.temporarilyUninherited.push(field.id);
    },
    inheritField(field) {
      var fieldIndex=this.temporarilyUninherited.indexOf(field.id);
      if (fieldIndex!=-1)
        this.temporarilyUninherited.splice(fieldIndex, 1);
      var dbFieldId=field.dbfield || this.fieldDesc[field.id];
      var targetItem=this.item;
      if (dbFieldId?.localize)
        targetItem=this.currentLocalization(dbFieldId.localize);
      targetItem[field.id]=null;
    },
    currentLocalization(localizationFields) {
      var localizationType=(localizationFields || []).join("|");
      var localization=localizationFields.map(field=>this.localizations?.[field] || "").join("|");
      if (!this.item._localizations)
        this.item._localizations={};
      if (!this.item._localizations[localizationType])
        this.item._localizations[localizationType]={};
      if (!this.item._localizations[localizationType][localization])
        this.item._localizations[localizationType][localization]={};

      return this.item._localizations[localizationType][localization];
    },
    parentCurrentLocalization(localizationFields) {
      var localizationType=(localizationFields || []).join("|");
      var localization=localizationFields.map(field=>this.localizations?.[field] || "").join("|");
      if (!this.item.parent._localizations)
        this.item.parent._localizations={};
      if (!this.item.parent._localizations[localizationType])
        this.item.parent._localizations[localizationType]={};
      if (!this.item.parent._localizations[localizationType][localization])
        this.item.parent._localizations[localizationType][localization]={};

      return this.item.parent._localizations[localizationType][localization];
    },
    fieldType(field) {
      var fieldData=field.dbfield || this.fieldDesc[field.id];
      var fieldType=field.type || (fieldData?.type) || "input";
      fieldType=(fieldTypeMap[fieldType]?.[0]) || fieldType;
      if (fieldType.startsWith("varchar"))
        fieldType="input";
      if (fieldType=="enum" || field.enum)
        fieldType="select";
      if (fieldType=="binary(16)") {
        fieldType="relUuid";
      }
      fieldType=fieldType.replace(/\(.*$/, "");
      if (fieldType=="decimal")
        fieldType="input";
      return fieldType;
    },
    formLabelClassFor(field) {
      var fieldType=this.fieldType(field);
      var fieldTypeLabelClassMap={
        relOne: "label-rel-one",
        relMany: "label-rel-many",
      };
      return fieldTypeLabelClassMap[fieldType] || "";
    },
    formComponentFor(field) {
      var fieldType=this.fieldType(field);
      if (field.component)
        return ""+field.component;
      var baseComponent="Form"+fieldType[0].toUpperCase()+fieldType.substring(1);

      var fieldData=field.dbfield || this.fieldDesc[field.id];
      if (fieldData?.target) {
        var dataSpecificCompoent=baseComponent+fieldData.target;
        var oldSilent = VueApp.config.warnHandler
        VueApp.config.warnHandler = () => null;
        if (typeof(resolveComponent(dataSpecificCompoent))!="string")
          return dataSpecificCompoent;
        VueApp.config.warnHandler = oldSilent
      }

      return baseComponent;
    },
    formArgsFor(field) {
      var fieldData=field.dbfield || this.fieldDesc[field.id];
      var fieldType=field.type || (fieldData?.type) || "input";
      var props=(fieldTypeMap[fieldType]?.[1]) || {};
      if (field.enum) {
        props.options=field.enum.map(item=>(typeof(item)!="object"?{
          value: item,
          text: item,
        }:item));
      }
      if (typeof(field.componentProps)=="object")
        for(var prop in field.componentProps)
          props[prop]=field.componentProps[prop];
      return props;
    },
  },

}
</script>

